var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat107(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_107"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_107",
    "data-name": 107,
    className: "cls-2",
    d: "M19.06,95.55c-9.36-7.92,1.35-29.61,5.1-37.81a163.52,163.52,0,0,1,22.17-35.4C51.39,16.17,64.2-1.46,73.92,2.71c10.55,4.53,8,26,6.62,34.73C77.62,56.49,68,74.69,52.37,86.27,45.3,91.51,27.66,102.83,19.06,95.55Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat107);
export default __webpack_public_path__ + "static/media/cat_107.ef27122d5af6578439b5ebd43c1864cd.svg";
export { ForwardRef as ReactComponent };